/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_portada.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Reserva from "../../Dialogos/Dialogo_Reserva";

const Home_Portada = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Reserva})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.45) 100%), url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',

            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: sCell ? 24 : 30}}>
                    <Typography
                        sx={{
                            fontSize: sCell ? 48 : 64,
                            fontWeight: 600,
                            textAlign: 'center',
                            fontFamily: NEGRITA,
                            lineHeight: 1.2
                        }}>Comodidad,
                        Tranquilidad y
                        Calidez</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{fontSize: sCell ? 18 : 24, fontWeight: 400, textAlign: 'center', lineHeight: 1.2}}>
                        En el Hotel Mar Azul disfrutarás de un ambiente cómodo y tranquilo, con un equipo que te recibe
                        con calidez y profesionalismo.
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 10, mb: 14}}>
                    <Button
                        onClick={() => abrir()}
                        color={'secondary'}>RESERVAR HABITACION</Button>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Portada    